import { defineComponent as w, toRefs as A, computed as u, reactive as E, openBlock as c, createElementBlock as I, normalizeClass as L, unref as t, renderSlot as m, normalizeProps as p, mergeProps as s, createBlock as v, withCtx as g, createVNode as x, createCommentVNode as y, resolveDynamicComponent as R } from "vue";
import { SfScrollableDirection as P, SfScrollableButtonsPlacement as o } from "@storefront-ui/shared";
import { useScrollable as j } from "../../composables/useScrollable/useScrollable.mjs";
import S from "../SfButton/SfButton.vue.mjs";
import q from "../SfIcons/SfIconChevronLeft.vue.mjs";
import M from "../SfIcons/SfIconChevronRight.vue.mjs";
import { ClassProp as O } from "../../shared/props.mjs";
const U = /* @__PURE__ */ w({
  inheritAttrs: !1,
  __name: "SfScrollable",
  props: {
    tag: {
      type: [String, Object],
      default: "div"
    },
    direction: {
      type: String,
      default: P.horizontal
    },
    buttonsPlacement: {
      type: String,
      default: o.block
    },
    wrapperClass: O,
    activeIndex: {
      type: Number,
      default: void 0
    },
    reduceMotion: {
      type: Boolean,
      default: void 0
    },
    drag: {
      type: [Object, Boolean],
      default: void 0
    },
    prevDisabled: {
      type: Boolean,
      default: void 0
    },
    nextDisabled: {
      type: Boolean,
      default: void 0
    },
    isActiveIndexCentered: {
      type: Boolean,
      default: !1
    },
    buttonPrevAriaLabel: {
      type: String,
      default: "Previous"
    },
    buttonNextAriaLabel: {
      type: String,
      default: "Next"
    }
  },
  emits: ["onDragStart", "onDragEnd", "onScroll", "onPrev", "onNext"],
  setup(a, { emit: B }) {
    const r = a, i = B, { direction: h, activeIndex: D, reduceMotion: k, drag: z, isActiveIndexCentered: C } = A(r), { containerRef: N, state: $, getNextButtonProps: b, getPrevButtonProps: f } = j(
      u(() => ({
        ...E({
          direction: h,
          activeIndex: D,
          reduceMotion: k,
          drag: z,
          isActiveIndexCentered: C
        }),
        onDragStart: (e) => i("onDragStart", e),
        onDragEnd: (e) => i("onDragEnd", e),
        onScroll: (e) => i("onScroll", e),
        onPrev: (e) => i("onPrev", e),
        onNext: (e) => i("onNext", e)
      }))
    ), l = u(() => r.direction === P.horizontal), n = u(() => r.buttonsPlacement === o.floating), d = u(() => r.buttonsPlacement === o.block);
    return (e, V) => (c(), I("div", {
      class: L(["items-center", "relative", l.value ? "flex" : "flex-col h-full inline-flex", a.wrapperClass])
    }, [
      e.$slots.previousButton && a.buttonsPlacement !== t(o).none ? m(e.$slots, "previousButton", p(s({ key: 0 }, t(f)))) : a.buttonsPlacement !== t(o).none ? (c(), v(t(S), s({
        key: 1,
        variant: "secondary",
        size: "lg",
        square: "",
        class: [
          "!rounded-full bg-white hidden md:block !ring-neutral-500 !text-neutral-500",
          {
            "mr-4": d.value && l.value,
            "mb-4 rotate-90": d.value && !l.value,
            "absolute left-4 z-10": n.value && l.value,
            "absolute top-4 rotate-90 z-10": n.value && !l.value
          },
          n.value ? "disabled:hidden" : "disabled:!ring-disabled-300 disabled:!text-disabled-500"
        ]
      }, t(f), {
        disabled: a.prevDisabled || t(f).disabled,
        "aria-label": a.buttonPrevAriaLabel
      }), {
        default: g(() => [
          x(t(q))
        ]),
        _: 1
      }, 16, ["class", "disabled", "aria-label"])) : y("", !0),
      (c(), v(R(a.tag), s({
        ref_key: "containerRef",
        ref: N,
        class: [
          "motion-safe:scroll-smooth",
          {
            "overflow-x-auto flex gap-4": l.value,
            "overflow-y-auto flex flex-col gap-4": !l.value,
            "cursor-grab": t($).isDragged
          }
        ]
      }, { ...e.$attrs, ...r }, { disabled: a.prevDisabled }), {
        default: g(() => [
          m(e.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "disabled"])),
      e.$slots.nextButton && a.buttonsPlacement !== t(o).none ? m(e.$slots, "nextButton", p(s({ key: 2 }, t(b)))) : a.buttonsPlacement !== t(o).none ? (c(), v(t(S), s({
        key: 3,
        variant: "secondary",
        size: "lg",
        square: "",
        class: [
          "!rounded-full bg-white hidden md:block !ring-neutral-500 !text-neutral-500",
          {
            "ml-4": d.value && l.value,
            "mt-4 rotate-90": d.value && !l.value,
            "absolute right-4 z-10": n.value && l.value,
            "absolute bottom-4 rotate-90 z-10": n.value && !l.value
          },
          n.value ? "disabled:hidden" : "disabled:!ring-disabled-300 disabled:!text-disabled-500"
        ]
      }, t(b), {
        disabled: a.nextDisabled || t(b).disabled,
        "aria-label": a.buttonNextAriaLabel
      }), {
        default: g(() => [
          x(t(M))
        ]),
        _: 1
      }, 16, ["class", "disabled", "aria-label"])) : y("", !0)
    ], 2));
  }
});
export {
  U as default
};
